function whenRtl(likewise, otherwise) {
  return function v(props) {
    if (props.dir === 'rtl') {
      return likewise;
    }

    return otherwise;
  };
}

export { whenRtl };
